import _cloneDeep from 'lodash/cloneDeep';

/**
 * Вешаем слушатель на событие
 *
 * @method
 * @private
 */
function addListener(eventName) {
  const self = this;
  const component = self._component(eventName);

  if (self._inList(component) && !self._isListen(eventName)) {
    self.loggersList[component][eventName] = true;

    self._owner.subscribe(eventName, eventData => {
      console.info('LISTENER: ', eventName, _cloneDeep(eventData));
    });
  }

  return;
}

export default addListener;
